// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac30e4e6","455":"0e19d30e","977":"03831d6e"}[chunkId] + ".chunk.js";
};